import { isGuideDoc, docPathToCtxKey } from './urls';
import { StyledRouterLink, StyledLink } from 'developer-docs-shared-components/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const UI_COMPONENT_REF = '/reference/ui-components/';
const CRM_GUIDES = '/guides/crm/';

// Currently this method is singularly used to handle when there is a link to
// another Guide page that ends with a trailing slash: ie: link to media-bridge.
function handleHrefWithTrailingSlash(str) {
  if (str.endsWith('/')) {
    return str.slice(0, -1);
  }
  return str;
}
const changeHrefBasePath = (href, updatedBasePath) => {
  const hrefParts = href.split('/');
  const inAppDocsPath = 'doc';
  const developersSitePath = 'docs';
  const guidesSupportedPath = 'guides';
  if (hrefParts[1] === inAppDocsPath || hrefParts[1] === developersSitePath) {
    hrefParts[1] = updatedBasePath;
  }
  if (hrefParts[1] === guidesSupportedPath) {
    hrefParts[1] = '/docs/guides';
  }
  const updatedHref = hrefParts.join('/');
  return updatedHref;
};

/**
 * Handles for all in-app doc links that start with '/':
 *
 * If link is not for another /platform page: return an external link and update
 * the href to appropriate developers.hubspot.com/docs route
 *
 * If link is for another in-app doc page: check if it includes an anchor tag:
 * If it includes a same page anchor tag: return a link with direct path to anchor
 * Else return a relative link to href path.
 */
export const getInAppDocLink = ({
  href,
  children
}) => {
  // Return External Link if link is not for another /platform page
  if (!href.includes(UI_COMPONENT_REF) && !href.includes(CRM_GUIDES)) {
    const updatedHref = changeHrefBasePath(href, 'docs');
    return /*#__PURE__*/_jsx(StyledLink, {
      href: `https://developers.hubspot.com${updatedHref}`,
      external: true,
      children: children
    });
  }
  if (href.includes('#')) {
    const split = href.split('#');
    const onSamePage = window.location.pathname.includes(split[0]);
    if (onSamePage) {
      return /*#__PURE__*/_jsx(StyledLink, {
        href: `#${split[1]}`,
        children: children
      });
    }
  }
  return /*#__PURE__*/_jsx(StyledRouterLink, {
    to: href,
    children: children
  });
};

/**
 * For all hrefs that start with '/doc':
 * If link is for a guides page that exists on new site: then check for anchor.
 * If it includes a same page anchor tag: return a link with direct path to anchor.
 * Else return a relative link to the supported guides href path.
 *
 * If the link is for a guide that does not exist on the new site: then return
 * an external link and update the href to appropriate
 * developers.hubspot.com/docs route
 */
export const getDocumentationPageLink = ({
  href,
  children
}) => {
  const [basePath, anchor] = handleHrefWithTrailingSlash(href).split('#');
  if (isGuideDoc(docPathToCtxKey(basePath))) {
    if (anchor) {
      const supportedGuideBasePath = changeHrefBasePath(basePath, 'guides');
      const onSamePage = window.location.pathname.includes(supportedGuideBasePath);
      if (onSamePage) {
        return /*#__PURE__*/_jsx(StyledLink, {
          href: `#${anchor}`,
          children: children
        });
      }
    }
    const supportedGuideRoute = changeHrefBasePath(handleHrefWithTrailingSlash(href), 'guides');
    return /*#__PURE__*/_jsx(StyledRouterLink, {
      to: supportedGuideRoute,
      children: children
    });
  }
  const updatedHref = changeHrefBasePath(href, 'docs');
  return /*#__PURE__*/_jsx(StyledLink, {
    href: `https://developers.hubspot.com${updatedHref}`,
    external: true,
    children: children
  });
};